import { render } from "./BusinessCardCollectionItem.vue?vue&type=template&id=795fcf21&scoped=true"
import script from "./BusinessCardCollectionItem.vue?vue&type=script&lang=js"
export * from "./BusinessCardCollectionItem.vue?vue&type=script&lang=js"

import "./BusinessCardCollectionItem.vue?vue&type=style&index=0&id=795fcf21&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795fcf21"]])

export default __exports__